module.exports = __webpack_public_path__ + "img/official-5.e763da44.png";